import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";


import facialcasmara from "../images/services/facial/brand/facialcasmara.webp";
import facialo3 from "../images/services/facial/brand/facialo3.webp";
import facialthalgo from "../images/services/facial/brand/facialthalgo.webp";
import facialrepechage from "../images/services/facial/brand/facialrepechage.webp";
import facialzenith from "../images/services/facial/brand/facialzenith.webp";
import facialkorean from "../images/services/facial/brand/facialkorean.webp";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const facialBrands = [
  { name: "Casmara", slug: "casmara", image: facialcasmara, desc: "Premium Spanish facials" },
  { name: "O3+", slug: "o3", image: facialo3, desc: "Dermat-approved skin care" },
  { name: "Thalgo", slug: "thalgo", image: facialthalgo, desc: "Luxury marine facials" },
  { name: "Repechage", slug: "repechage", image: facialrepechage, desc: "Advanced clinical facials" },
  { name: "Zenith", slug: "zenith", image: facialzenith, desc: "Glow & repair therapies" },
  { name: "Korean", slug: "korean", image: facialkorean, desc: "Glass skin treatments" },
];

const FacialServices = () => {
  const navigate = useNavigate();

  return (
   <div style={{ backgroundColor: "#f7ead7", minHeight: "100vh" }}>
      <Header />
      <Navbar />

      {/* Hero Section */}
      <section className="bg-light py-4">
        <div className="container text-center">
          <h2 className="fw-bold">Facial Services</h2>
          <p className="text-muted mb-0">
            Choose from premium facial brands & skin treatments
          </p>
        </div>
      </section>

      {/* Brands Section */}
      <section className="container my-4">
        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
          {facialBrands.map((brand, idx) => (
            <div key={idx} className="col">
              <div
                className="card h-100 border-0 shadow-sm facial-brand-card"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/category/facialservices/${brand.slug}`)}
              >
                <img
                  src={brand.image}
                  className="card-img-top"
                  alt={brand.name}
                  style={{ height: "160px", objectFit: "cover" }}
                />

                <div className="card-body text-center">
                  <h6 className="fw-bold mb-1">{brand.name}</h6>
                  <p className="text-muted small mb-0">{brand.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Why choose section */}
      <section className="container my-5">
        <div className="row text-center">
          <div className="col-md-4 mb-3">
            <h6 className="fw-bold">🌸 Certified Products</h6>
            <p className="text-muted small">Only branded & dermat-tested cosmetics</p>
          </div>
          <div className="col-md-4 mb-3">
            <h6 className="fw-bold">⏱ Time-based Services</h6>
            <p className="text-muted small">Slots blocked as per facial duration</p>
          </div>
          <div className="col-md-4 mb-3">
            <h6 className="fw-bold">👩‍🔧 Trained Beauticians</h6>
            <p className="text-muted small">Background-verified professionals</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FacialServices;
